export const GoogleMapApiConfig = 'AIzaSyAGoUTvBKyQ-pulrnqHjFXDKDdP8q45e5k';